import { render, staticRenderFns } from "./deals-menu.vue?vue&type=template&id=732dbc7e&scoped=true"
import script from "./deals-menu.vue?vue&type=script&lang=js"
export * from "./deals-menu.vue?vue&type=script&lang=js"
import style0 from "./deals-menu.vue?vue&type=style&index=0&id=732dbc7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732dbc7e",
  null
  
)

export default component.exports